import React from 'react';
import {Text, View} from 'react-native';
import {Str_NoData} from "../language/string_res";
import { color_333333 } from '../assets/style/colors';

export const ListEmpty = () => {
    return (
        <View
            style={{
                flex: 1,
                alignItems: 'center',
                justifyContent: 'center',
                paddingVertical: 60,
            }}>
            <Text style={{
                color: color_333333,
                fontSize: 15,
                opacity: 0.6,
            }}>{Str_NoData}</Text>
        </View>
    );
};
